// extracted by mini-css-extract-plugin
export default {"img":"CollectionSlides_img__beB4X"};